import { AxiosResponse } from 'axios';
import { DEVICE_INFO_API_URL, USERS_API_URL } from '../../../../config';
import deviceAxios from '../../../../utils/axios/device.axios';
import userAxios from '../../../../utils/axios/user.axios';

const tryToFetchModels = (): Promise<AxiosResponse<any>> => {
    return deviceAxios.get(`${DEVICE_INFO_API_URL}/ai-models/all`);
};

const tryToEditModel = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/ai-search-engine/add-search-engines`, data);
};

const tryToGetUserModels = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/ai-search-engine/user-enabled-ai-models`, data);
};

const tryToDeleteUserModels = (data: any): Promise<AxiosResponse<any>> => {
    return deviceAxios.put(`${DEVICE_INFO_API_URL}/ai-search-engine/delete-search-engines`, data);
};

const tryToTriggerRunLeo = (): Promise<AxiosResponse<any>> => {
    return deviceAxios.post(`${DEVICE_INFO_API_URL}/leo/trigger-run`);
};

const tryToInviteNewMember = (data: any): Promise<AxiosResponse<any>> => {
    return userAxios.put(`${USERS_API_URL}/demo-requests/invite/by-email`, data);
};

export const ModelsService = {
    tryToFetchModels,
    tryToEditModel,
    tryToDeleteUserModels,
    tryToGetUserModels,
    tryToTriggerRunLeo,
    tryToInviteNewMember
};